import BaseHttpService from "../services/base.http.service";

class BaseService extends BaseHttpService {
  constructor(baseUrl: string = "") {
    super(baseUrl);
  }
}

export default BaseService;
